import { type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const EmptyLayout = ({
  icon: Icon,
  title,
  message,
  onClick,
  buttonIcon: ButtonIcon,
  buttonIconClassName,
  buttonText,
  containerClassName,
  messageClassName,
  disabled,
  disabledMessage,
}: {
  icon?: LucideIcon;
  title: string;
  message: string;
  onClick?: () => void;
  buttonIcon?: LucideIcon;
  buttonIconClassName?: string;
  buttonText?: string;
  containerClassName?: string;
  messageClassName?: string;
  disabled?: boolean;
  disabledMessage?: string;
}) => (
  <div
    className={cn(
      'flex h-full max-h-full flex-col items-center justify-center gap-y-2 overflow-y-auto bg-ui-container p-4',
      containerClassName,
    )}
    data-cy="empty-layout"
  >
    {Icon && <Icon className="icon-64 min-h-20 text-icon-base" strokeWidth={0.5} />}
    <div className="flex flex-col gap-y-1">
      <h4
        className="line-clamp-5 max-w-xl text-center text-2xl text-balance wrap-anywhere text-text-base"
        data-cy="empty-layout-title"
      >
        {title}
      </h4>
      <div
        className={cn('max-w-lg mx-auto text-balance px-16 text-center text-text-gray', messageClassName)}
        data-cy="empty-layout-message"
      >
        {message}
      </div>
    </div>
    {((onClick && buttonText) ?? (buttonText && disabled)) && (
      <Button
        variant="navigation-action-primary"
        {...(onClick && { onClick })}
        className="mt-2 gap-x-2 px-6 py-3 focus-visible:ring-offset-ui-container"
        disabled={disabled}
        data-cy="empty-layout-button"
        aria-label={buttonText}
        icon={ButtonIcon}
        iconClassName={buttonIconClassName}
      >
        {buttonText}
      </Button>
    )}
    {disabled && disabledMessage && (
      <span className="max-w-sm text-center text-xs text-status-warning" data-cy="empty-layout-disabled-message">
        {disabledMessage}
      </span>
    )}
  </div>
);
